import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rl-drag-handle',
  templateUrl: './drag-handle.component.html',
  styleUrls: ['./drag-handle.component.scss']
})
export class DragHandleComponent{

  @Input() order : number;
  @Input() maxOrder : number = 0;
  @Input() minOrder : number = 0;
  @Output() orderChange = new EventEmitter<number>()
  
  constructor() { }
  
  updateOrder(order : number){
    if(order <= this.maxOrder && order >= this.minOrder){
      this.order = order;
      this.orderChange.emit(this.order)
    }
  }
}
